import React, { useEffect, useState } from 'react';
import { formatCurrency, getDataWithJoin } from '../../../utils/SamuiUtils';
import { formatDate } from '../../../utils/DateUtils';
import Pagination from '../Footer/Pagination';

const ViewHistoryItem = ({ open, onClose, itemId }) => {

    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPageDropdown, setItemsPerPageDropdown] = useState(10);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPageDropdown(Number(e.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const startIndex = (currentPage - 1) * itemsPerPageDropdown + 1;
    const endIndex = Math.min(startIndex + itemsPerPageDropdown - 1, data.length);

    useEffect(() => {
        if (open && itemId) {
            fetchData();
        }
    }, [open, itemId, startDate, endDate]);

    const fetchData = async () => {
        let whereClause = `WHERE PD.Item_Id = ${itemId}`;
        if (startDate) {
            whereClause += ` AND PH.Pay_Date >= '${startDate}'`;
        }
        if (endDate) {
            whereClause += ` AND PH.Pay_Date <= '${endDate}'`;
        }
        whereClause += " ORDER BY PH.Pay_Date DESC, PH.Pay_No DESC";
        const response = await getDataWithJoin(
            `
                PH.Pay_Date, 
                PH.Pay_No, 
                PH.AP_Name, 
                PD.Item_Name, 
                PD.Item_Qty, 
                PD.Item_Unit, 
                PD.Item_Price_Unit,
                PD.Item_Discount, 
                PD.Item_DisType,
                PD.Item_Total 
            `,
            "API_0401_PAY_H PH",
            "LEFT JOIN API_0402_PAY_D PD ON PD.Pay_Id = PH.Pay_Id",
            whereClause
        );

        if (response && response.length > 0) {
            setData(response);
        } else {
            setData([]);
        }
    };

    if (!open) return null;

    return (
        <div className={`modal ${open ? 'show' : ''}`} style={{ display: open ? 'block' : 'none' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl" role="document" style={{ maxWidth: '80%' }}>
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#EF6C00', color: '#fff' }}>
                        <h5 className="modal-title text-white">ประวัติการซื้อสินค้า</h5>
                        <button type="button" className="btn btn-close cursor-pointer" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="row g-3 mb-3">
                            <div className="col-md-3">
                                <label className="form-label">วันที่</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={startDate}
                                    onChange={e => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">ถึงวันที่</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={endDate}
                                    onChange={e => setEndDate(e.target.value)}
                                />
                            </div>
                            <div className="col-md-12 d-flex justify-content-end">
                                <button
                                    type="button"
                                    className="btn btn-lg btn-danger"
                                    onClick={() => {
                                        setStartDate('');
                                        setEndDate('');
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead>
                                    <tr style={{ backgroundColor: '#EF6C00', color: '#fff' }}>
                                        <th className="text-center text-white">วันที่ใบสำคัญจ่าย</th>
                                        <th className="text-center text-white">เลขที่ใบสำคัญจ่าย</th>
                                        <th className="text-center text-white">ผู้ขาย</th>
                                        <th className="text-center text-white">ชื่อสินค้า</th>
                                        <th className="text-center text-white">จำนวน</th>
                                        <th className="text-center text-white">หน่วย</th>
                                        <th className="text-center text-white">ราคาต่อหน่วย</th>
                                        <th className="text-center text-white">ส่วนลด</th>
                                        <th className="text-center text-white">%</th>
                                        <th className="text-center text-white">จำนวนเงินรวม</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.length > 0 ? (
                                        data.map((row, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{formatDate(row.Pay_Date)}</td>
                                                <td className="text-center">{row.Pay_No}</td>
                                                <td className="text-left">{row.AP_Name}</td>
                                                <td className="text-left">{row.Item_Name}</td>
                                                <td className="text-end">{row.Item_Qty}</td>
                                                <td className="text-center">{row.Item_Unit}</td>
                                                <td className="text-end">{formatCurrency(row.Item_Price_Unit)}</td>
                                                <td className="text-end">{formatCurrency(row.Item_Discount)}</td>
                                                <td className="text-center">
                                                    {row.Item_DisType === 1 ? '฿' : row.Item_DisType === 2 ? '%' : row.Item_DisType}
                                                </td>
                                                <td className="text-end">{formatCurrency(row.Item_Total)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center text-muted">ยังไม่มีข้อมูลแสดง</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {/* Footer */}
                            <div className="d-flex justify-content-between align-items-center p-3">
                                <div>
                                    <select
                                        value={itemsPerPageDropdown}
                                        onChange={handleItemsPerPageChange}
                                        className="form-select"
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                                <div>
                                    <span>
                                        แสดง {data.length === 0 ? 0 : startIndex}-{endIndex} ของ{" "}
                                        {data.length.toLocaleString()} รายการ
                                    </span>
                                </div>
                                <Pagination
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    itemsPerPage={itemsPerPageDropdown}
                                    dataMasterList={data}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>ปิด</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewHistoryItem;